import React from 'react';
import { Badge } from '@eventbrite/marmalade';
import { MessageDescriptor, useIntl } from 'react-intl';
import classNames from 'classnames';
import styles from './IconCategoryCard.module.scss';

export interface CardContent {
    titleMessage: MessageDescriptor;
    icon: React.ReactNode;
    showNewBadge: boolean;
}

export const IconCategoryCard: React.FunctionComponent<CardContent> = ({
    titleMessage,
    icon,
    showNewBadge,
}) => {
    const intl = useIntl();
    const displayTitle = intl.formatMessage(titleMessage);

    return (
        <div className={styles.root}>
            <div className={styles.iconWrapper} data-testid="icon-wrapper">
                {icon}

                {showNewBadge && (
                    <div className={styles.badgeContainer}>
                        <Badge variant="bold" className={styles.newBadge}>
                            New
                        </Badge>
                    </div>
                )}
            </div>
            <p className={classNames(styles.title, styles.textWeightHeavy)}>{displayTitle}</p>
        </div>
    );
};
